function menu() {
    
    const body = document.querySelector(".js-body"),
        menuButton = document.querySelector(".js-menu-button"),
        menuCloseButton = document.querySelector(".js-menu-close"),
        animateMenuTop = document.querySelectorAll(".js-menu-top-animate"),
        animateMenuBtm = document.querySelectorAll(".js-menu-btm-animate"),
        // header = document.querySelector(".js-header"),
        menu = document.querySelector(".js-menu"),
        stopScrollingClass = "stop-scrolling",
        isActiveClass = "is-active"
    ;

    //open menu timeline
    const menuOpenTl = gsap.timeline({ paused:true });
    menuOpenTl.to(menu, 0.3, { autoAlpha: 1, ease: Power1.easeInOut })
              .to(animateMenuTop, 0.3, { autoAlpha: 1, marginTop: 0, ease: Power1.easeInOut }, "-=0.2")
              .to(animateMenuBtm, 0.3, { autoAlpha: 1, marginBottom: 0, ease: Power1.easeInOut }, "-=0.3");

    //close menu timeline
    const menuCloseTl = gsap.timeline({ paused:true });
    menuCloseTl.to(animateMenuTop, 0.3, { autoAlpha: 1, marginTop: "2rem", ease: Power1.easeInOut })
               .to(animateMenuBtm, 0.3, { autoAlpha: 1, marginBottom: "-2rem", ease: Power1.easeInOut }, "-=0.3")
               .to(menu, 0.3, { autoAlpha: 0, ease: Power1.easeInOut }, "-=0.2");
              

    //bind events
    menuButton.addEventListener("click", (e) => {
        e.preventDefault();
        body.classList.add(stopScrollingClass, isActiveClass);
        openMenuAnimations(menuOpenTl,menuCloseTl);            
    });

    menuCloseButton.addEventListener("click", (e) => {
        e.preventDefault();
        closeMenuAnimations(menuOpenTl,menuCloseTl);
        body.classList.remove(stopScrollingClass, isActiveClass);
    })


}

 //functions
function openMenuAnimations(menuOpenTl,menuCloseTl) {
    menuCloseTl.pause();
    menuOpenTl.restart();
}

function closeMenuAnimations(menuOpenTl,menuCloseTl) {
    menuOpenTl.pause();
    menuCloseTl.restart();
}